/**
 * Helpers to dispatch/clear processing GIF messages.
 * ProcessingGif.tsx listens for the 'toggle-processing-gifs' CustomEvent.
 *
 * emitProcessingMessages uses setTimeout(0) to defer the event dispatch.
 * This ensures ProcessingGif has mounted and registered its event listener
 * (setLoading(true) triggers a re-render, but the component doesn't mount
 * until after the current synchronous block finishes).
 */

export function emitProcessingMessages(customMessages?: string[] | null, actions?: number[] | null) {
  setTimeout(() => {
    window.dispatchEvent(
      new CustomEvent('toggle-processing-gifs', {
        detail: { customMessages, actions },
      })
    )
  }, 0)
}

export function clearProcessingMessages() {
  window.dispatchEvent(
    new CustomEvent('toggle-processing-gifs', {
      detail: { customMessages: null, actions: null },
    })
  )
}
